import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
const ProtectedRoute: React.FC = () => {
  const {
    isAuthenticated
  } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace data-id="element-147" />;
  }
  // Return just the Outlet, since Layout is already wrapped around this component in App.tsx
  return <Outlet data-id="element-148" />;
};
export default ProtectedRoute;